import { messaging, firestore} from "../../firebase/firebase.js";
import { getToken, onMessage } from "firebase/messaging";
import { firebaseConfig } from "../../firebase/firebase.js";

// Request notification permission from the user
export const requestNotificationPermission = async () => {
  if(messaging != null) {
	  try {
		const token = await getToken(messaging, {
		  vapidKey: firebaseConfig.vapidKey,
		});

		if (token) {
		  console.log("FCM Token:", token);
		  return token;  // Save this token to Firestore for sending notifications
		} else {
		  console.log("No registration token available.");
		}
	  } catch (error) {
		console.error("Error requesting notification permissions:", error);
	  }
  }
};

// Handle incoming notifications when the app is in the foreground
export const listenForNotifications = () => {
  if(messaging != null) {
	  console.log("New notification setup!!!:");

	  onMessage(messaging, (payload) => {
		console.log("New notification received:", payload);
		//alert(`?? ${payload.notification.title}: ${payload.notification.body}`);
	  });
  }
};
